import googleLogo from '../../../assets/icons/google.svg';
import { AButton } from '../../../components/Button';

export const useGoogleButton = (isLogin: boolean) => {
  const GOOGLE_CALLBACK_URL = process.env.REACT_APP_GOOGLE_CALLBACK_URL;
  const GOOGLE_CLIENT_ID =
    '496728186718-7eiv6ug4c1a5bs5bkcifbsrlh5478vbc.apps.googleusercontent.com';
  const googleUrl = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${GOOGLE_CALLBACK_URL}&prompt=consent&response_type=code&client_id=${GOOGLE_CLIENT_ID}&scope=openid%20email%20profile&access_type=offline`;

  const GoogleBtn = (
    <AButton href={googleUrl} className="w-full">
      <img src={googleLogo} alt="Google Logo" className="w-6 h-6" />
      {isLogin ? 'Sign in' : 'Register'} with Google
    </AButton>
  );

  return { GoogleBtn };
};
